import * as React from 'react';
import { Helmet } from 'react-helmet';

import { AboutRenderer, IRenderProps } from '../models/About';

class Meta extends React.PureComponent<IRenderProps> {
  render() {
    const image = this.props.data.fields.metaImage.fields.file.url;
    const description = this.props.data.fields.description
      .split(/\r?\n/)[0]
      .trim();
    const prefix = this.props.data.fields.metaTitlePrefix;
    const suffix = this.props.data.fields.metaTitleDefaultSuffix;

    return (
      <Helmet titleTemplate={`${prefix} | %s`} defaultTitle={suffix}>
        <meta property="og:image" content={image} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${prefix} | ${suffix}`} />
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
      </Helmet>
    );
  }
}

export default function Wrapper() {
  return <AboutRenderer render={Meta} />;
}



// WEBPACK FOOTER //
// ./src/components/Meta.tsx